module.exports = __webpack_public_path__ + "img/xhlogo.013baf24.png";